export const images = [
    {
        id: 1,
        url: "images/foto1.jpg",
        alias: "imagen1"
    },
    {
        id: 2,
        url: "images/foto2.jpg",
        alias: "imagen2"
    },
    {
        id: 3,
        url: "images/foto3.jpg",
        alias: "imagen3"
    },
    {
        id: 4,
        url: "images/foto4.jpg",
        alias: "imagen4"
    },
    {
        id: 5,
        url: "images/foto5.jpg",
        alias: "imagen5"
    },
    {
        id: 6,
        url: "images/foto6.jpg",
        alias: "imagen6"
    },
    {
        id: 7,
        url: "images/logo1.jpg",
        alias: "imagen7"
    },
    {
        id: 8,
        url: "images/logo2.jpg",
        alias: "imagen8"
    },
    {
        id: 9,
        url: "images/logo3.jpg",
        alias: "imagen9"
    },
    {
        id: 10,
        url: "images/logo4.jpg",
        alias: "imagen10"
    },
    {
        id: 11,
        url: "images/lona1.jpg",
        alias: "imagen11"
    },
    {
        id: 12,
        url: "images/menu1.jpg",
        alias: "imagen12"
    },
    {
        id: 13,
        url: "images/pedido1.png",
        alias: "imagen13"
    },
    {
        id: 14,
        url: "images/precios1.jpg",
        alias: "imagen14"
    },
    {
        id: 15,
        url: "images/precios2.jpg",
        alias: "imagen15"
    },
    {
        id: 16,
        url: "images/taco1.jpg",
        alias: "imagen16"
    },
    {
        id: 17,
        url: "images/taco2.jpg",
        alias: "imagen17"
    },
    {
        id: 18,
        url: "images/taco3.jpg",
        alias: "imagen18"
    },
    {
        id: 19,
        url: "images/taco4.jpg",
        alias: "imagen19"
    },
    {
        id: 20,
        url: "images/taco5.jpg",
        alias: "imagen20"
    },
    {
        id: 21,
        url: "images/taco6.jpg",
        alias: "imagen21"
    },
    {
        id: 22,
        url: "images/taco7.jpg",
        alias: "imagen22"
    },
    {
        id: 23,
        url: "images/taco8.jpg",
        alias: "imagen23"
    },
    {
        id: 24,
        url: "images/taco9.jpg",
        alias: "imagen24"
    },
    {
        id: 25,
        url: "images/taco10.jpg",
        alias: "imagen25"
    },
    {
        id: 26,
        url: "images/taco11.jpg",
        alias: "imagen26"
    },
    {
        id: 27,
        url: "images/taco12.jpg",
        alias: "imagen27"
    },
    {
        id: 28,
        url: "images/taco13.jpg",
        alias: "imagen28"
    },
]